import { Mutation, Typenames } from '@varo/graphql-schema-types';
import DisburseFromLineOfCredit from 'services/graphql/queries/DisburseFromLineOfCredit';
import { getUuid } from 'shared/utils/getUuid/getUuid';
import { useMutation } from 'urql';

const useSubmitVlocApplication = () => {
  const [{ error, fetching, data: response }, executeMutation] =
    useMutation<Mutation>(DisburseFromLineOfCredit);

  const isError =
    !fetching &&
    (!response ||
      response.disburseFromLineOfCredit.__typename ===
        Typenames.DisburseFromLineOfCreditError);
  const isSuccessful =
    response?.disburseFromLineOfCredit.__typename ===
    Typenames.DisburseFromLineOfCreditSuccess;

  const triggerMutation = (tierId: string, autoPayEnabled: boolean) => {
    void executeMutation({
      idempotencyId: getUuid(),
      tierId,
      autoPayEnabled,
    });
  };

  return {
    isError,
    isSuccessful,
    response,
    error,
    fetching,
    triggerMutation,
  };
};

export default useSubmitVlocApplication;
